// Messages for portal/OtpChallenge (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'portal.otp.head': 'Two-factor — Customer portal',
  'portal.otp.title': 'Two-factor verification',
  'portal.otp.intro': 'Enter the 6-digit code from your authenticator app, or a recovery code.',
  'portal.otp.code': 'Verification code',
  'portal.otp.code_error': 'Code {error}',
  'portal.otp.submit': 'Verify',
}

export const zhTW = {
  'portal.otp.head': '雙重驗證 — 客戶入口',
  'portal.otp.title': '雙重驗證',
  'portal.otp.intro': '輸入驗證器應用程式中的 6 位數代碼，或一組復原代碼。',
  'portal.otp.code': '驗證代碼',
  'portal.otp.code_error': '代碼 {error}',
  'portal.otp.submit': '驗證',
}
